// The iPad board's readings (TOM-980): the stack over the chart (wind, depth,
// distance to the anchor) and the three cards beside it (wind and weather, the
// house battery with its 48-hour line, fresh water). Every value is from
// Gallivant RP's record through homeScene.ts.
import { HOUSE_SPARK_AREA, HOUSE_SPARK_LINE, SPARK_HEIGHT, SPARK_WIDTH } from './ipadChart';
import { SCENE_ANCHOR, SCENE_READINGS as R } from './homeScene';

/** The bar under a reading takes the anchor watch's state; the record reads "holding". */
const ANCHOR_BAR_CLASS = {
  holding: '',
  drag_suspected: ' home-bar__fill--caution',
  outside: ' home-bar__fill--alarm',
}[SCENE_ANCHOR];

export function ChartReadouts() {
  return (
    <div className="home-readouts">
      <div className="home-readout">
        <span className="home-ipad__label">WIND</span>
        <span className="home-readout__value">
          {R.windKn} <span className="home-unit">kn</span>
        </span>
        <span className="home-bar home-bar--short">
          <span className="home-bar__fill" style={{ width: '100%' }} />
        </span>
      </div>
      <div className="home-readout">
        <span className="home-ipad__label">DEPTH</span>
        <span className="home-readout__value">
          {R.depthFt} <span className="home-unit">ft</span>
        </span>
        <span className="home-bar home-bar--short">
          <span className="home-bar__fill" style={{ width: '100%' }} />
        </span>
      </div>
      <div className="home-readout">
        <span className="home-ipad__label">TO ANCHOR</span>
        <span className="home-readout__value">
          {R.toAnchorFt} <span className="home-unit">ft</span>
        </span>
        <span className="home-bar home-bar--short">
          <span
            className={`home-bar__fill${ANCHOR_BAR_CLASS}`}
            style={{ width: `${R.toAnchorPct}%` }}
          />
        </span>
      </div>
    </div>
  );
}

export function IpadCards() {
  return (
    <div className="home-cards">
      <div className="home-card home-card--wind">
        <span className="home-ipad__label">WIND · WEATHER</span>
        <div className="home-card__wind">
          <svg className="home-compass" aria-hidden="true" viewBox="0 0 60 60" fill="none">
            <circle className="home-compass__ring" cx="30" cy="30" r="24" />
            <path className="home-compass__ticks" d="M30 4 V10 M30 50 V56 M4 30 H10 M50 30 H56" />
            <text className="home-compass__n" x="30" y="19" textAnchor="middle">
              N
            </text>
            <g className="home-compass__arrow" transform={`rotate(${R.windFromDeg} 30 30)`}>
              <path d="M30 8 V30" />
              <path d="M24 23 L30 31 L36 23" />
            </g>
          </svg>
          <div className="home-card__stack">
            <span className="home-card__big">{R.windKn} kn</span>
            <span className="home-card__words">{R.windWords}</span>
          </div>
        </div>
        <div className="home-card__pair">
          <div>
            <span className="home-ipad__label home-ipad__label--small">PRESSURE</span>
            <span className="home-card__value">{R.pressureHpa} hPa</span>
          </div>
          <div>
            <span className="home-ipad__label home-ipad__label--small">AIR</span>
            <span className="home-card__value">{R.airF} °F</span>
          </div>
        </div>
      </div>

      <div className="home-card home-card--grow">
        <span className="home-ipad__label home-card__head">
          <span>HOUSE BATTERY</span>
          <span>48 H</span>
        </span>
        <span className="home-card__mid">
          {R.housePct}% <span className="home-unit home-unit--small">{R.houseV} V</span>
        </span>
        <svg
          className="home-spark"
          aria-hidden="true"
          viewBox={`0 0 ${SPARK_WIDTH} ${SPARK_HEIGHT}`}
          preserveAspectRatio="none"
          fill="none"
        >
          <path className="home-spark__area" d={HOUSE_SPARK_AREA} />
          <path
            className="home-spark__line"
            d={HOUSE_SPARK_LINE}
            vectorEffect="non-scaling-stroke"
          />
        </svg>
      </div>

      <div className="home-card">
        <span className="home-ipad__label">FRESH WATER</span>
        <span className="home-card__mid">
          {R.waterGal} gal{' '}
          <span className="home-unit home-unit--small">of {R.waterCapacityGal}</span>
        </span>
        <span className="home-bar home-bar--wide">
          <span className="home-bar__fill" style={{ width: `${R.waterPct}%` }} />
        </span>
      </div>
    </div>
  );
}
